import moment from "moment";
import { useEffect, useState } from "react";
import TooltipExplanation from "../shared/Tooltip";
import { CurrentTimeContainer } from "./style";

const LOCAL_TZ_ABBR =
  new Intl.DateTimeFormat(undefined, { timeZoneName: "short" })
    .formatToParts(new Date())
    .find((p) => p.type === "timeZoneName")?.value ?? "Local";

function CurrentTimeUTC() {
  const [currentTime, setCurrentTime] = useState(moment().format("HH:mm:ss"));
  const [utcTime, setUtcTime] = useState(moment().utc().format("HH:mm:ss"));

  useEffect(() => {
    // Update time every 1 second
    const int = setInterval(() => {
      setCurrentTime(moment().format("HH:mm:ss"));
      setUtcTime(moment().utc().format("HH:mm:ss"));
    }, 1000);
    return () => clearInterval(int);
  }, []);

  return (
    <TooltipExplanation
      title="UTC Time"
      placement="top"
      explanation={`${utcTime} UTC`}
      renderContent={(props) => (
        <CurrentTimeContainer {...props}>
          <span>{currentTime}</span>
          <span>{LOCAL_TZ_ABBR}</span>
        </CurrentTimeContainer>
      )}
    />
  );
}

export default CurrentTimeUTC;
